const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTask(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "assignment_turned_in"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_2864_35570",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 16,
    height: 16
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Bounding box",
    width: 16,
    height: 16,
    fill: "#D9D9D9",
    style: {
      fill: "#D9D9D9",
      fill: "color(display-p3 0.8510 0.8510 0.8510)",
      fillOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_2864_35570)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "assignment_turned_in_2",
    d: "M7.06667 10.7003L11.7667 6.00033L10.8333 5.06699L7.06667 8.83366L5.16667 6.93366L4.23333 7.86699L7.06667 10.7003ZM3.33333 14.0003C2.96667 14.0003 2.65278 13.8698 2.39167 13.6087C2.13056 13.3475 2 13.0337 2 12.667V3.33366C2 2.96699 2.13056 2.6531 2.39167 2.39199C2.65278 2.13088 2.96667 2.00033 3.33333 2.00033H6.13333C6.27778 1.60033 6.51944 1.2781 6.85833 1.03366C7.19722 0.789214 7.57778 0.666992 8 0.666992C8.42222 0.666992 8.80278 0.789214 9.14167 1.03366C9.48056 1.2781 9.72222 1.60033 9.86667 2.00033H12.6667C13.0333 2.00033 13.3472 2.13088 13.6083 2.39199C13.8694 2.6531 14 2.96699 14 3.33366V12.667C14 13.0337 13.8694 13.3475 13.6083 13.6087C13.3472 13.8698 13.0333 14.0003 12.6667 14.0003H3.33333ZM3.33333 12.667H12.6667V3.33366H3.33333V12.667ZM8 2.83366C8.14444 2.83366 8.26389 2.78644 8.35833 2.69199C8.45278 2.59755 8.5 2.4781 8.5 2.33366C8.5 2.18921 8.45278 2.06977 8.35833 1.97533C8.26389 1.88088 8.14444 1.83366 8 1.83366C7.85556 1.83366 7.73611 1.88088 7.64167 1.97533C7.54722 2.06977 7.5 2.18921 7.5 2.33366C7.5 2.4781 7.54722 2.59755 7.64167 2.69199C7.73611 2.78644 7.85556 2.83366 8 2.83366Z",
    fill: "#FFC300",
    style: {
      fill: "#FFC300",
      fill: "color(display-p3 1.0000 0.7647 0.0000)",
      fillOpacity: 1
    }
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTask);
export default __webpack_public_path__ + "static/media/task.b7186957600199f6f57ed66974bd6761.svg";
export { ForwardRef as ReactComponent };